import { render, staticRenderFns } from "./OwnerListPage.vue?vue&type=template&id=d459832e"
import script from "./OwnerListPage.vue?vue&type=script&lang=js"
export * from "./OwnerListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports